import styles from "./InputField.module.scss";

const RangeField = ({
  type = "date",
  nameTo,
  nameFrom,
  label,
  register,
  validationFrom = {},
  validationTo = {},
  errors,
  required = false,
  placeholder = "",
  isStatic = false,
  readOnly = false,
  watch = null,
}) => {
  // invald Date判定
  const isInvalidDate = (date) => Number.isNaN(date.getDate());

  const inputMax = () => {
    if (type === "date") {
      return "9999-12-31";
    } else if (type === "datetime-local") {
      return "9999-12-31T23:59";
    } else {
      return null;
    }
  };

  const returnDateText = (name) => {
    let returnVal = "";
    if (isStatic) {
      // 入力欄の値取得
      const val = watch(name);
      const dVal = new Date(watch(name));
      if (val && !isInvalidDate(dVal)) {
        let y = dVal.getFullYear();
        let m = dVal.getMonth() + 1;
        let d = dVal.getDate();
        if (type === "date") {
          returnVal = y + "年" + m + "月" + d + "日";
        } else if (type === "datetime-local") {
          let h = dVal.getHours();
          let mn = dVal.getMinutes();
          returnVal =
            y +
            "年" +
            m +
            "月" +
            d +
            "日" +
            String(h).padStart(2, "0") +
            "時" +
            String(mn).padStart(2, "0") +
            "分";
        }
      }
    }
    return returnVal;
  };

  return (
    <div
      className={
        styles.field__range + " " + (isStatic ? styles.rangestaticlabel : "")
      }
    >
      <label className={`form-label ${styles.field__label}`}>
        {label}
        <span className={styles.field__label__required}>
          {required && !isStatic ? "必須" : ""}
        </span>
      </label>

      <input
        className={`${styles.field__range__input__from} ${
          errors[nameFrom] ? "is-invalid" : ""
        } ${isStatic ? "form-control-plaintext d-none" : "form-control"}`}
        type={type}
        placeholder={placeholder}
        {...register(nameFrom, validationFrom)}
        readOnly={isStatic || readOnly}
        max={inputMax()}
      />
      {isStatic ? (
        <div className={`${styles.staticlabel} form-control-plaintext`}>
          {returnDateText(nameFrom)}
        </div>
      ) : (
        <></>
      )}
      <label className={styles.field__range__label}>から</label>
      <input
        className={`${styles.field__range__input__to} ${
          errors[nameTo] ? "is-invalid" : ""
        } ${isStatic ? "form-control-plaintext d-none" : "form-control"}`}
        type={type}
        placeholder={placeholder}
        {...register(nameTo, validationTo)}
        readOnly={isStatic || readOnly}
        max={inputMax()}
      />
      {isStatic ? (
        <div className={`${styles.staticlabel} form-control-plaintext`}>
          {returnDateText(nameTo)}
        </div>
      ) : (
        <></>
      )}
      <p className={`invalid-feedback ${styles.field__range__msg__from}`}>
        {errors[nameFrom] ? errors[nameFrom].message : ""}
      </p>
      <p className={`invalid-feedback ${styles.field__range__msg__to}`}>
        {errors[nameTo] ? errors[nameTo].message : ""}
      </p>
    </div>
  );
};

export default RangeField;
